<mat-tab-group mat-align-tabs="start" (selectedTabChange)="onTabChanged();">
  <!-- #enddocregion align-start -->
  <mat-tab label="Bank Cards">
    <div class="container tabs-container">
      <div class="alinear-derecha">
        <p>Got Amex, Chase Bank, or other cards? Then you got assets to transfer. Transfer your cashback points, rewards or miles you've earned with bank cards like Amex, Chase Bank or others into <strong>cryptMi</strong>.</p>
        <p>Also, add the rewards you have on your <strong>Miles Digital Card</strong>.</p>
        <div class="img-franquicias">
          <img src="./assets/img/cryptmi/franquicias-1.webp" alt="">
          <img src="./assets/img/cryptmi/franquicias-2.webp" alt="">
        </div>
        <ul class="bl-modal__list bl-modal__list--tab">
          <li><span>1</span> <p>Go to “<strong>My Wallet</strong>” on the main menu.</p></li>
          <li><span>2</span> <p>Tap the <span class="icon-card icon-card--next"></span> icon to select the “<strong>Transfer</strong>’ option</p></li>
          <li><span>3</span> <p>Tap on the “<strong>Cards</strong>” button</p></li>
          <li><span>4</span> <p>Enter the amount of funds you want to transfer, then choose the card you want to transfer from</p></li>
          <li><span>5</span> <p>Tap on “<strong>Confirm</strong>’</p></li>
          <li class="last"><p><strong>Done</strong>! You've just completed your transfer!</p></li>
        </ul>
        <div class="find">
          <p>Didn't add any cards to <strong>cryptMi</strong> yet?<br>
            Find out how to do so</p>
          <div class="btn btn-more" (click)="me()"></div>
        </div>
      </div>
      <div class="alinear-izquierda">
        <div class="phone">
          <div class="content">
            <video class="video-vimeo" autoplay="" loop="loop" oncanplay="this.play()" onloadedmetadata="this.muted = true" playsinline="" poster="" autoplay="">
              <source
                src="https://player.vimeo.com/progressive_redirect/playback/708795725/rendition/540p/file.mp4?loc=external&signature=2cb43b9832ac54f088ee251250f82c0f899b7fd0578fc8a4be481a09d6bfa401"
                type="video/mp4">
            </video>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Cryptocurrencies">
    <div class="container tabs-container cryptocurrencies">
      <div class="alinear-derecha">
        <p>Got crypto? Transfer them to <strong>cryptMi</strong> from Coinbase, MetaMask or any other crypto wallet, and connect them with points, miles, cards and e-wallets to increase your purchase power.</p>
        <p>Buy, sell or convert Bitcoin, Ethereum and 150+ cryptocurrencies, and earn more rewards in the process.</p>
        <div class="slide-cripto">
          <div class="animate2">
            <img class="cryptos" src="./assets/img/cryptmi/cryptos.png" alt="">
          </div>
        </div>
        <ul class="bl-modal__list bl-modal__list--tab">
          <li><span>1</span> <p>If you have cryptocurrencies outside cryptMi and want to transfer them, go to <strong>"My Wallet"</strong> on the main menu
          </p></li>
          <li><span>2</span> <p>Touch the <span class="icon-card icon-card--next"></span>  icon to select the <strong>“Transfer’’</strong> option.</p></li>
          <li><span>3</span> <p>Tap the <strong>“Crypto”</strong> button and make sure to select the “Receive” option</p></li>
          <li><span>4</span> <p>Choose the cryptocurrency you want to transfer, and copy the link address that will appear afterward</p></li>
          <li><span>5</span> <p>Tap the wallet icon where you have your cryptocurrencies and log in to your account</p></li>
          <li><span>6</span> <p>Follow the steps to complete the transfer on your external wallet</p></li>
          <li class="last"><p><strong>All set!</strong> Your cryptocurrencies will be automatically uploaded to the list of digital assets in your <strong>cryptMi</strong> wallet and will be reflected in your balance so that you can pay with them at any merchant around the world.
          </p></li>
        </ul>
      </div>
      <div class="alinear-izquierda">
        <div class="phone">
          <div class="content">
            <video class="video-vimeo" autoplay="" loop="loop" oncanplay="this.play()" onloadedmetadata="this.muted = true" playsinline="" poster="" autoplay="">
              <source
                src="https://player.vimeo.com/progressive_redirect/playback/708795752/rendition/540p/file.mp4?loc=external&signature=1fe66667a31cf8e2e25472c9d454a7be98fa57c0ce11edc4bd36f908dbea0aef"
                type="video/mp4">
            </video>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="e-wallet">
    <div class="container tabs-container">
      <div class="alinear-derecha">
        <p>Transfer your rewards, cashbacks, miles and points from Apple Cash or any card activated in your Apple Pay, Google Pay or other virtual wallets.</p>
        <img class="pay" src="./assets/img/cryptmi/pay.png" alt="">
        <ul class="bl-modal__list bl-modal__list--tab">
          <li><span>1</span> <p>Go to My Wallet on the main menu.</p></li>
          <li><span>2</span> <p>Touch the <span class="icon-card icon-card--next"></span> icon to select the <strong>“Transfer”</strong> option.</p></li>
          <li><span>3</span> <p>Tap on the <strong>“E-Wallets”</strong> button.</p></li>
          <li><span>4</span> <p>Enter the value of the funds you want to transfer and tap the button of your virtual wallet.</p></li>
          <li><span>5</span> <p>There, select the payment method or card.</p></li>
          <li class="last"><p><strong>Voilà!</strong> Your e-wallet is now active on cryptMi so that you can start making payments anytime, anywhere.</p></li>
        </ul>
      </div>
      <div class="alinear-izquierda">
        <div class="phone">
          <div class="content">
          <video class="video-vimeo" autoplay="" loop="loop" oncanplay="this.play()" onloadedmetadata="this.muted = true" playsinline="" poster="">
              <source
                src="https://player.vimeo.com/progressive_redirect/playback/708795771/rendition/540p/file.mp4?loc=external&signature=19eb3003a5f3349799045469990e99d32cb776b1d6278d70803fed6ae4f48331"
                type="video/mp4">
            </video>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Buy now pay later">
    <div class="container tabs-container">
      <div class="alinear-derecha">
        <p>If you have a finance agreement with Klarna, Afterpay or another BNPL-type program, you can transfer those balances over to <strong>cryptMi</strong> and keep paying installments as per your contract.</p>
        <img class="pay-later" src="./assets/img/cryptmi/pay-later.png" alt="">
        <ul class="bl-modal__list bl-modal__list--tab">
          <li><span>1</span> <p>Go to My Wallet on the main menu.</p></li>
          <li><span>2</span> <p>Touch the <span class="icon-card icon-card--next"></span> icon to select the <strong>"Transfer"</strong> option.</p></li>
          <li><span>3</span> <p>Swipe the browser and tap the <strong>"Buy Now, Pay Later"</strong> button.</p></li>
          <li><span>4</span> <p>Set the value to transfer, then select your financing program.</p></li>
          <li class="last"><p><strong>That’s it!</strong> The value you transferred will be paid in installments according to your program terms.</p></li>
        </ul>
      </div>
      <div class="alinear-izquierda">
        <div class="phone">
          <div class="content">
            <video class="video-vimeo" autoplay="" loop="loop" oncanplay="this.play()" onloadedmetadata="this.muted = true" playsinline="" poster="">
              <source
                src="https://player.vimeo.com/progressive_redirect/playback/708795799/rendition/540p/file.mp4?loc=external&signature=6b12a94f7f023b449b4c12b62d50a062dfc811e73390c1b34271caaeec8e4352"
                type="video/mp4">
            </video>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Bank direct access">
    <div class="container tabs-container">
      <div class="alinear-derecha">
        <p>Transfer funds to <strong>cryptMi</strong> from any of the banks listed below.</p>
        <p>Just tap the corresponding icon and follow the instructions.</p>
        <img class="access" src="./assets/img/cryptmi/direct-access.png" alt="">
      </div>
      <div class="alinear-izquierda">
        <div class="phone">
          <div class="content">
            <video class="video-vimeo" autoplay="" loop="loop" oncanplay="this.play()" onloadedmetadata="this.muted = true" playsinline="" poster="">
              <source
                src="https://player.vimeo.com/progressive_redirect/playback/708795850/rendition/540p/file.mp4?loc=external&signature=615f94e1952c37c95c0c00864aeab32c7be8737dc5e67fe74db1c3814a6b32fd"
                type="video/mp4">
            </video>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Vouchers">
    <div class="container tabs-container">
      <div class="alinear-derecha">
        <p>If you have vouchers with OXXO, Boleto or Konbini, take advantage and transfer them to cryptMi to level up your purchase power.</p>
        <p>Just tap the corresponding icon and follow the steps.</p>
        <img class="banks vouchers" src="./assets/img/cryptmi/vouchers.png" alt="">
      </div>
      <div class="alinear-izquierda">
        <div class="phone">
          <div class="content">
            <video class="video-vimeo" autoplay="" loop="loop" oncanplay="this.play()" onloadedmetadata="this.muted = true" playsinline="" poster="">
              <source
                src="https://player.vimeo.com/progressive_redirect/playback/708795890/rendition/540p/file.mp4?loc=external&signature=8c8c7845fb1653c7ca8d1a46bf1ae5f5d23215df73ff6cb414dfb63bf219e5db"
                type="video/mp4">
            </video>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>